import { _ as s } from "./index979.mjs";
import { _ as r } from "./index817.mjs";
import { _ } from "./index831.mjs";
var a = s, e = r, t = _;
function h() {
  this.size = 0, this.__data__ = {
    hash: new a(),
    map: new (t || e)(),
    string: new a()
  };
}
var o = h;
export {
  o as _
};
